/* eslint-disable @typescript-eslint/no-explicit-any */
import MarkDown from '~/components/Helpers/MarkDown'
import HtmlBlock from '~/components/Helpers/HtmlBlock'
import { cn } from '~/lib/utils'
import Icon, { IconProps } from '~/components/Helpers/Icon'

export type FeatureItemProps = {
  content: {
    heading?: string
    copy: string
    icon?: IconProps['icon']
    character?: string
    type: 'icon' | 'alphanumeric'
  }
  layoutColour?: AllBackgroundColours
  className?: string
}

const FeatureItem = ({
  content,
  className,
  layoutColour
}: FeatureItemProps) => {
  const { heading, copy, type } = content

  const icon = Array.isArray(content.icon) ? content.icon[0] : content.icon
  const character = content.character || '1'

  return (
    <div className={cn('sm:gap-xs-plus gap-xs flex items-center', className)}>
      <div className='min-w-l flex justify-center sm:min-w-[56px] lg:min-w-xl'>
        {icon && type === 'icon' && (
          <Icon
            className={cn(
              'w-full object-cover sm:max-w-full sm:[&>img]:min-w-[56px] lg:[&>img]:min-w-xl'
            )}
            icon={icon}
            backgroundColour={layoutColour}
          />
        )}
        {(type === 'alphanumeric' || !icon) && (
          <span className='sm:text-h1-lg text-h1-md font-serif'>
            {character.toUpperCase()}
          </span>
        )}
      </div>
      <div>
        {heading && (
          <MarkDown content={'**' + heading + '**'} className='mb-3xs' />
        )}

        <HtmlBlock content={copy} />
        {/* <MarkDown
          content={copy}
          components={{
            h6: ({ children }: any) => <p>{children}</p>
          }}
        /> */}
      </div>
    </div>
  )
}

export default FeatureItem
